import * as React from "react";
import { MenuItem, makeStyles } from "@material-ui/core";
import { TextField } from "formik-material-ui";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 140,
  },
}));

const InputFormSelect = (props) => {
  const { options, label = "" } = props;
  const classes = useStyles();

  return (
    <TextField {...props} className={classes.formControl} label={label} select>
      {options.map((option) => (
        <MenuItem value={option.value} key={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default InputFormSelect;
